const localizedGlobalName = "localized";
const LocalizedString = (key) => window[localizedGlobalName][key] ?? key;

export default LocalizedString;
